import { useQuery } from 'react-query';

import { getCurrentUserPermissions } from 'src/utils/api/org/getCurrentUserPermissions';

import {
  CurrentUserPermissionsResponse,
  EmployeePermissionApiValue,
  hasEmployeePermission,
} from './currentUserPermissions';

export const CURRENT_USER_PERMISSIONS_QUERY_KEY = ['current-user-permissions'];

type UseCurrentUserPermissionsResult = {
  data: CurrentUserPermissionsResponse | undefined;
  loading: boolean;
  error: unknown;
};

/**
 * Loads the authenticated employee's role and permissions from `/org/me`.
 */
export function useCurrentUserPermissions(): UseCurrentUserPermissionsResult {
  const { data, isLoading, error } = useQuery(CURRENT_USER_PERMISSIONS_QUERY_KEY, getCurrentUserPermissions, {
    staleTime: 60_000,
  });

  return { data, loading: isLoading, error };
}

/**
 * Returns whether the current user has the given employee permission.
 */
export function useHasEmployeePermission(permission: EmployeePermissionApiValue): {
  permission: boolean;
  loading: boolean;
} {
  const { data, loading } = useCurrentUserPermissions();

  if (loading) {
    return { permission: false, loading: true };
  }

  return {
    permission: hasEmployeePermission(data?.permissions, permission),
    loading: false,
  };
}
